import api from "./api";

interface SiderbarFolderSortParams {
  folder_detail: {
    id: string;
    sort_order: number;
  }[];
}

interface SiderbarFolderSortProps {
  folderDetail: {
    id: string;
    sortOrder: number;
  }[];
}

// 文件夹排序
export const sidebarFolderSort = async (props: SiderbarFolderSortProps) => {
  const params: SiderbarFolderSortParams = {
    folder_detail: props.folderDetail.map(item => ({
      id: item.id,
      sort_order: item.sortOrder,
    })),
  };
  const res = await api.post<unknown>("/sidebar/folder/sort", params);
  return res;
};
